export default defineNuxtPlugin({
  name: 'jgi-i18n',
  enforce: 'pre',
  setup() {
    const { load, locale } = useI18n();
    load();

    // Sinkron html lang sejak awal + saat berubah
    if (import.meta.client) {
      watch(
        locale,
        (code) => {
          document.documentElement.lang = code === 'en' ? 'en' : 'id';
          document.documentElement.dataset.locale = code;
        },
        { immediate: true }
      );
    }
  },
});
